module.exports = __webpack_public_path__ + "img/temp2.e1e4fa82.svg";